import { injectable } from 'inversify';

import { ITeamLeaguePlayersRepository } from '@/domain/repositories/team-leagues-players.repository.interface';
import { Result } from '@/entities/Result';
import {
	addTeamLeaguePlayer,
	listTeamLeaguePlayersWithChecks,
	listTeamLeaguesPlayers,
	tradePlayers
} from '@/infrastructure/network/data/team-leagues-players';
import { TeamLeagueAddPlayerResponse } from '@/infrastructure/network/dto/TeamLeagueAddPlayerDto';
import { SearchParams } from '@/entities/SearchParams';
import { TeamPlayerInfo } from '@/lib/types';
import { PlayerInfoResponse } from '@/entities';

@injectable()
export class TeamLeaguePlayersRepository implements ITeamLeaguePlayersRepository {
	async getTeamLeaguesPlayers(organizationUuid: string, teamLeagueUuid: string, searchParams: SearchParams): Promise<Result<PlayerInfoResponse>> {
		const result = await listTeamLeaguesPlayers({ organizationUuid, teamLeagueUuid, searchParams });
		if (result.statusCode === 200) {
			return { data: result.data, statusCode: result.statusCode };
		} else {
			return { statusCode: result.statusCode, correlationId: result.correlationId, error: result.error };
		}
	}

	async addTeamLeaguePlayer(
		organizationUuid: string,
		teamLeagueUuid: string,
		teamUuid: string,
		playerUuid: string
	): Promise<Result<TeamLeagueAddPlayerResponse>> {
		const result = await addTeamLeaguePlayer({ organizationUuid, teamLeagueUuid, teamUuid, playerUuid });
		if (result.statusCode === 200) {
			return { data: result.data, statusCode: result.statusCode };
		} else {
			return { statusCode: result.statusCode, correlationId: result.correlationId, error: result.error };
		}
	}

	async tradePlayers(
		organizationUuid: string,
		teamLeagueUuid: string,
		teamUuid: string,
		playersLeavingTeam: string[],
		playersJoiningTeam: string[],
		receivingTeamUuid: string
	): Promise<Result<TeamLeagueAddPlayerResponse>> {
		const result = await tradePlayers({
			organizationUuid,
			teamLeagueUuid,
			teamUuid,
			playersLeavingTeam,
			playersJoiningTeam,
			receivingTeamUuid
		});
		if (result.statusCode === 200) {
			return { data: result.data, statusCode: result.statusCode };
		} else {
			return { statusCode: result.statusCode, correlationId: result.correlationId, error: result.error };
		}
	}

	async getTeamLeaguesPlayersWithChecks(
		organizationUuid: string,
		teamLeagueUuid: string,
		searchParams: SearchParams
	): Promise<Result<TeamPlayerInfo[]>> {
		const result = await listTeamLeaguePlayersWithChecks({ organizationUuid, teamLeagueUuid, searchParams });
		if (result.statusCode === 200) {
			return { data: result.data.results.teamLeaguePlayersInfo, statusCode: result.statusCode };
		} else {
			return { statusCode: result.statusCode, correlationId: result.correlationId, error: result.error };
		}
	}
}
